<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on, attrs}">
              <v-btn
              color="success"
              :loading="buttonLoading"
              v-bind="attrs"
              v-on="on"
              ><v-icon>cloud_download</v-icon>Export</v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAll()">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="ExportAll()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm12 v-if="responseError">
              <span class="red--text">{{ responseError }}</span>
            </v-flex>
            <v-flex sm3>
              <v-select
                v-model="queryParams.financeSettingId"
                :items="financeSettingList"
                color="blue-grey lighten-2"
                label="Choose Finance Setting..."
                item-text="financialYearName"
                menu-props="auto"
                item-value="id"
                @input="bindMonth(queryParams.financeSettingId)"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.fromMonth"
                    label="From Month"
                    prepend-icon="event"
                    readonly
                    :disabled="queryParams.financeSettingId ? false : true"
                    v-on="on"
                    hint="Please Select financeSetting ."
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.fromMonth"
                  type="month"
                  :min="minMonth"
                  :max="maxMonth"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.toMonth"
                    label="To Month"
                    prepend-icon="event"
                    readonly
                    :disabled="queryParams.financeSettingId ? false : true"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.toMonth"
                  type="month"
                  :min="minMonth"
                  :max="maxMonth"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3 v-if="this.user.role.roleName != 'BRANCH_ADMIN'">
              <shop-autocomplete
                :param="Number(queryParams.shopId)"
                @set="setShop"
              />
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accountCode"
                label="Account Code"
                type="text"
                v-model="queryParams.accountCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accountName"
                label="Account Name"
                type="text"
                v-model="queryParams.accountName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="accountHeadList"
                label="Select Account Head"
                v-model="queryParams.accountHeadId"
                item-text="accountName"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="glListingList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            item-key="coaId"
            :must-sort="false"
          >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
                <td>
                  <v-btn
                    color="primary"
                    @click.stop="showGlListingDetailList(props.item)"
                    >Detail</v-btn
                  >
                </td>
                <td>{{ props.item.accountCode }}</td>
                <td>{{ props.item.accountName }}</td>
                <td>{{ props.item.accountHeadName }}</td>
                <td>{{ props.item.parentAccountCode }}</td>
                <td>{{ props.item.parentAccountName }}</td>
                <td
                  style="
                    width: calc(100% / 7);
                    overflow: hidden;
                    text-align: right;
                  "
                  class="text-xs"
                >
                  <span style="padding-left: 1em">
                    {{
                      props.item.openingBalance | decFormat(6)
                    }}
                  </span>
                </td>
                <td
                  style="
                    width: calc(100% / 7);
                    overflow: hidden;
                    text-align: right;
                  "
                  class="text-xs"
                >
                  <span style="padding-left: 1em">
                    {{
                      props.item.closingBalance | decFormat(6)
                    }}
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- gl detail list dialog -->
    <v-dialog v-model="showGLDetailListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="subheaders"
                :items="glListingDetailList"
                class="elevation-1"
                :loading="showListLoading"
                :rows-per-page-items="detailRowsPerPageItems"
                :pagination.sync="detailPagination"
                :must-sort="false"
              >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>
                      {{ props.item.glLedgerDateInMilliSeconds | formatMsDate }}
                    </td>
                    <td>{{ props.item.shopName }}</td>
                    <td>{{ props.item.glIssueNo }}</td>
                    <td>{{ props.item.operationSettingName }}</td>
                    <td>{{ props.item.glInvoiceNo }}</td>
                    <td>{{ props.item.glDescription }}</td>
                    <td>{{ props.item.glReference }}</td>
                    <td>{{ props.item.chequeNo }}</td>
                    <td>{{ props.item.ledgerBy }}</td>
                    <td style="text-align: right">
                      {{ props.item.debitAmount | decFormat(6) }}
                    </td>
                    <td style="text-align: right">
                      {{ props.item.creditAmount | decFormat(6) }}
                    </td>
                    <td style="text-align: right">
                      {{ props.item.closingAmount | decFormat(6) }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- gl reference detail list dialog -->
    <!-- <v-dialog
      v-model="showGLReferenceDetailListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="glreferencedetailheader"
                :items="glReferenceDetailList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="detailTotalRows"
                :rows-per-page-items="detailRowsPerPageItems"
                :pagination.sync="detailPagination"
                :must-sort="false"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{ props.item.createdDateInMilliSeconds | formatMsDate }}
                  </td>
                  <td>{{ props.item.glreferenceType }}</td>
                  <td>
                    {{ props.item.issueDateInMilliSeconds | formatMsDate }}
                  </td>
                  <td>{{ props.item.invoiceNo }}</td>
                  <td style="text-align: right">
                    {{ props.item.amount | decFormat(6) }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <!-- < id="printGL"></invoice> -->
    <div
      id="printGL"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px; font-weight: bold">
          {{ shopName }}
        </p>
      </div>

      <div style="text-align: center">
        <p style="font-size: 15px; margin: 0px">General Ledger Listing</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 0px">
          From ({{ queryParams.fromMonth }}) to ({{ queryParams.toMonth }})
        </p>
      </div>
      <div style="float: left; padding-left: 11px">
        <p style="font-size: 15px; margin: 0px" id="counter">
          Created Date : {{ currentDate | formatDate }}
        </p>
      </div>
      <div style="float: right; padding-right: 11px">
        <p style="font-size: 15px; margin: 0px" id="counter">
          Created By : {{ user.username }}
        </p>
      </div>
      <br />
      <div style="clear: both"></div>
      <div style="height: 10px"></div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border: 1px solid black;
          "
        >
          <tbody v-for="(glListing, i) in allglListingList" :key="i">
            <tr style="border: 1px solid black; text-align: left">
              <td colspan="3">
                <span>Account Code {{ glListing.accountCode }}</span>
                <br />
                <span>Account Name {{ glListing.accountName }}</span>
                <br />
                <span>Parent Code {{ glListing.parentAccountCode }}</span>
                <br />
                <span>Parent Name {{ glListing.parentAccountName }}</span>
              </td>
              <td colspan="2">
                <span>Account Head {{ glListing.accountHeadName }}</span>
              </td>
              <td colspan="3" style="text-align: right">
                <span
                  >Opening Balance
                  {{
                    glListing.openingBalance | decFormat(6)
                  }}</span
                >
                <br />
                <span
                  >Closing Balance
                  {{
                    glListing.closingBalance | decFormat(6)
                  }}</span
                >
              </td>
            </tr>
            <tr v-if="glListing.glListingDetailList.length > 0">
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">Shop</th>
              <th style="border: 1px solid black; text-align: center">
                Issue No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Operation Setting Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Description
              </th>
              <th style="border: 1px solid black; text-align: center">Debit</th>
              <th style="border: 1px solid black; text-align: center">
                Credit
              </th>
              <th style="border: 1px solid black; text-align: center">
                Closing Balance
              </th>
            </tr>
            <tr
              v-for="(item, index) in glListing.glListingDetailList"
              :key="index"
            >
              <td style="border: 1px solid black; text-align: center">
                <span>{{
                  item.glLedgerDateInMilliSeconds | formatMsDate
                }}</span>
              </td>
              <td style="border: 1px solid black; text-align: left">
                <span>{{ item.shopName }}</span>
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.glIssueNo }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.operationSettingName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.glDescription }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.debitAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.closingAmount | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
        <div style="height: 10px"></div>
      </div>
    </div>
    <!-- End print  -->
  </v-container>
</template>
<script>
import ShopAutocomplete from "../templates/ShopAutocomplete.vue";
import { commonService } from "../../services/common-service";
import { glListingService } from "../../services/gl-listing-service";
import { financeSettingService } from "../../services/finance-setting-service";
import { accountHeadService } from "../../services/account-head-service";
export default {
  name: "GLListing",
  components: { ShopAutocomplete },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showGLReferenceDetailListDialog: false,
    showGLDetailListDialog: false,
    showFilters: false,
    shopName: "",
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "General Ledger Listing",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", align: "center", value: "action", sortable: false },
      { text: "Account Code", align: "left", value: "accountCode" },
      { text: "Account Name", value: "accountName" },
      { text: "Account Head", value: "accountHeadName" },
      { text: "Parent Account Code", value: "parentAccountCode" },
      { text: "Parent Account Name", value: "parentAccountName" },
      { text: "Opening Balance", value: "openingBalance" },
      { text: "Closing Balance", value: "closingBalance" },
    ],
    subheaders: [
      {
        text: "Date",
        align: "left",
        value: "glLedgerDateInMilliSeconds",
        sortable: false,
      },
      { text: "Shop", align: "left", value: "shopName", sortable: false },
      { text: "Issue No", align: "left", value: "glIssueNo", sortable: false },
      {
        text: "Operation Setting Name",
        align: "left",
        value: "operationSettingName",
        sortable: false,
      },
      { text: "Invoice No", value: "glInvoiceNo", sortable: false },
      { text: "Description", value: "glDescription", sortable: false },
      { text: "Reference", value: "glReference", sortable: false },
      { text: "Cheque No", value: "chequeNo", sortable: false },
      { text: "Ledger By", value: "ledgerBy", sortable: false },
      { text: "Debit", align: "left", value: "debitAmount", sortable: false },
      { text: "Credit", align: "left", value: "creditAmount", sortable: false },
      {
        text: "Closing Balance",
        align: "left",
        value: "closingAmount",
        sortable: false,
      },
    ],

    glreferencedetailheader: [
      { text: "Date", value: "createdDateInMilliSeconds" },
      { text: "Ref Type", value: "glreferenceType" },
      { text: "Issue Date", value: "issueDateInMilliSeconds" },
      { text: "Invoice No", value: "invoiceNo" },
      { text: "Amount", value: "amount" },
    ],
    rowsPerPageItems: [10, 20, 30],
    decimalFormat: "",
    responseError: "",
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    detailPagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },
    detailRowsPerPageItems: [25, 50, 100],
    detailTotalRows: 0,
    allglListingList: [],
    glListingList: [],
    glListingDetailList: [],
    accountHeadList: [],
    totalRows: 0,
    queryParams: {
      fromMonth: new Date().toISOString().substr(0, 7),
      toMonth: new Date().toISOString().substr(0, 7),
      accountCode: "",
      shopId: "",
      financeSettingId: "",
      accountHeadId: "",
      accountName: "",
    },
    currentDate: new Date(),
    financeSettingList: [],
    glReferenceDetailList: [],
    buttonLoading: false,
    minMonth: "",
    maxMonth: "",
    cloneQueryParam: new Object(),
    glreferenceDetail: new Object(),
    accountId: "",
    generalLedgerListing: {},
  }),
  watch: {
    pagination: {
      handler() {
        this.getglListing();
      },
      deep: true,
    },
    // detailPagination: {
    //   handler() {
    //     this.getGlListingDetailList(this.generalLedgerListing);
    //   },
    //   deep: true,
    // },
  },

  created() {
    //for deep linking
    if (this.$route.query.fromMonth) {
      this.queryParams.fromMonth = this.$route.query.fromMonth;
    }
    if (this.$route.query.toMonth) {
      this.queryParams.toMonth = this.$route.query.toMonth;
    }
    if (this.$route.query.accountCode) {
      this.queryParams.accountCode = this.$route.query.accountCode;
    }
    if (this.$route.query.accountName) {
      this.queryParams.accountName = this.$route.query.accountName;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getFinanceSettingList();
    this.getAccountHeadList();
  },
  methods: {
    onSearch() {
      if (this.queryParams.financeSettingId) {
        this.queryParams.page = this.pagination.page;
        this.queryParams.size = this.pagination.rowsPerPage;
        if (this.user.role.roleName == "BRANCH_ADMIN") {
          this.queryParams.shopId = this.user.shopId;
        }
        this.$router.replace({
          name: "general-ledger-listing",
          query: this.queryParams,
        });
        this.getglListing();
        this.cloneQueryParam = JSON.parse(JSON.stringify(this.queryParams));
      } else {
        this.responseError = "Please Select Finance Setting.";
      }
    },

    setShop(obj) {
      this.shopName = obj.shopName;
      this.queryParams.shopId = obj.shopId;
    },

    getAccountHeadList() {
      accountHeadService
        .getAllAccountHead()
        .then((res) => {
          this.accountHeadList = res.data;
          let findAll = {
            id: "",
            accountName: "----All----",
          };
          this.accountHeadList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getFinanceSettingList() {
      financeSettingService
        .getAllFinanceSetting()
        .then((res) => {
          this.financeSettingList = res.data.financeSettingDTOs;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.response = err.response.data.message;
          }
        });
    },
    bindMonth(id) {
      let financeSetting = commonService.search(
        "id",
        id,
        this.financeSettingList
      );
      if (financeSetting) {
        this.minMonth = financeSetting.startMonth;
        this.maxMonth = financeSetting.endMonth;
        this.queryParams.fromMonth = financeSetting.startMonth;
        this.responseError = "";
      }
    },
    getglListing() {
      if (this.queryParams.financeSettingId) {
        this.showListLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";
        glListingService
          .getGLlisting(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.glListingList = res.data.glListingList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },

    showGlListingDetailList(item) {
      this.generalLedgerListing = item;
      this.getGlListingDetailList(item).then(() => {
        this.showGLDetailListDialog = !this.showGLDetailListDialog;
      });
    },
    getGlListingDetailList(item) {
      this.showListLoading = true;
      let order = this.detailPagination.descending ? "desc" : "asc";

      let searchParams = {
        fromMonth: this.queryParams.fromMonth,
        toMonth: this.queryParams.toMonth,
        shopId: this.queryParams.shopId,
        coaId: item.coaId,
        nature: item.nature,
        openingBalance: item.openingBalance,
        closingBalance: item.closingBalance,
      };
      return glListingService
        .getGlListingDetailList(
          searchParams,
          this.detailPagination.sortBy + "," + order
        )
        .then((res) => {
          this.glListingDetailList = res.data.glListingDetailList;
          this.detailTotalRows = res.data.totalElements;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    showGLReferenceDetails(glListDetail, coaId) {
      this.detail(glListDetail, coaId);
      this.glreferenceDetail = JSON.parse(JSON.stringify(glListDetail));
      this.accountId = coaId;
      this.showGLReferenceDetailListDialog =
        !this.showGLReferenceDetailListDialog;
    },

    detail(glListDetail, accountId) {
      this.showListLoading = true;
      let order = this.detailPagination.descending ? "desc" : "asc";
      glListingService
        .getGLreferenceDetailList(
          glListDetail.generalLedgerId,
          accountId,
          this.detailPagination.page,
          this.detailPagination.rowsPerPage,
          this.detailPagination.sortBy + "," + order
        )
        .then((res) => {
          this.glReferenceDetailList = res.data.glreferenceDetailList;
          this.detailTotalRows = res.data.totalElements;
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    ExportAll() {
      if (this.queryParams.financeSettingId) {
        this.buttonLoading = true;
        glListingService
          .getGlListingExcelExport(this.cloneQueryParam)
          .then((res) => {
            commonService.downloadE(res);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.buttonLoading = false;
          });
      } else {
        this.responseError = "Please Select Finance Setting .";
      }
    },
    printAll() {
      glListingService
        .getGLlistingPrint(this.cloneQueryParam)
        .then((res) => {
          this.allglListingList = res.data.glListingList;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printInvoice("printGL");
        });
    },
    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },
  },
};
</script>